import Http from "../../http/client";

export default async (id) => {
  const response = await Http.delete('admin/user/notes/'+id);
  return response.data;
}
